/* Gaver ved køb – vælg gave i kurven, fjern overskydende gaver, og mind kunden om ubrugte gavepoint */
(function () {
  'use strict';
  var T = window.theme || {};
  var root = ((T.routes && T.routes.root_url) || '/').replace(/\/$/, '');
  var busy = false;
  function post(url, body) {
    return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); });
  }
  function setCount() {
    return fetch(root + '/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; if (c.item_count > 0) el.removeAttribute('data-empty'); else el.setAttribute('data-empty', ''); });
    });
  }
  function refresh(inDrawer) {
    if (!inDrawer) { location.reload(); return Promise.resolve(); }
    return fetch(root + '/?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (j) {
      var d = document.querySelector('[data-cart-drawer]'); if (!d || !j['cart-drawer']) return;
      var tmp = document.createElement('div'); tmp.innerHTML = j['cart-drawer'];
      var inner = tmp.querySelector('[data-cd-inner]'), cur = d.querySelector('[data-cd-inner]');
      if (inner && cur) cur.innerHTML = inner.innerHTML;
      return setCount();
    }).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-gift-add]'); if (!b || b.disabled) return;
    e.preventDefault(); b.disabled = true;
    var inDrawer = !!b.closest('[data-cart-drawer]');
    var card = b.closest('.gp-card'), sel = card && card.querySelector('[data-gift-variant]');
    var vid = parseInt(sel ? sel.value : b.dataset.giftAdd, 10), qty = parseInt(b.dataset.giftQty, 10) || 1;
    post('/cart/add.js', { items: [{ id: vid, quantity: qty }] })
      .then(function (res) {
        if (!res.ok) { b.disabled = false; var t = document.getElementById('toast'); if (t) { t.textContent = res.j.description || res.j.message || 'Gaven kunne ikke tilføjes'; t.classList.add('on'); setTimeout(function () { t.classList.remove('on'); }, 2600); } return; }
        return refresh(inDrawer);
      })
      .catch(function () { b.disabled = false; });
  });
  function applyTab(scope) {
    var want = null; try { want = sessionStorage.getItem('gpTab'); } catch (e) {}
    (scope || document).querySelectorAll('[data-gift]').forEach(function (g) {
      var tabs = g.querySelectorAll('[data-gp-tab]'); if (!tabs.length) return;
      var has = want && g.querySelector('[data-gp-pane="' + want + '"]');
      var cur = has ? want : tabs[0].dataset.gpTab;
      tabs.forEach(function (t) { var on = t.dataset.gpTab === cur; t.classList.toggle('on', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
      g.querySelectorAll('[data-gp-pane]').forEach(function (p) { p.hidden = p.dataset.gpPane !== cur; });
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-gp-tab]'); if (!t) return;
    try { sessionStorage.setItem('gpTab', t.dataset.gpTab); } catch (err) {}
    applyTab(t.closest('[data-gift]').parentNode);
  });
  function check(scope) {
    var g = (scope || document).querySelector('[data-gift]'); if (!g || busy) return;
    var pts = parseInt(g.dataset.points, 10) || 0, used = parseInt(g.dataset.used, 10) || 0;
    if (used <= pts) return;
    var lines = []; try { lines = JSON.parse(g.dataset.lines || '[]'); } catch (err) { return; }
    var over = used - pts, updates = {};
    for (var i = lines.length - 1; i >= 0 && over > 0; i--) { updates[lines[i].key] = 0; over -= (lines[i].qty || 0); }
    busy = true;
    post('/cart/update.js', { updates: updates })
      .then(function () { return refresh(!!g.closest('[data-cart-drawer]')); })
      .finally(function () { busy = false; });
  }

  /* Påmindelse: kunden trykker "Til kassen" med ubrugte gavepoint (vises én gang pr. besøg) */
  var REMIND_KEY = 'gpRemindShown';
  function reminded() { try { return sessionStorage.getItem(REMIND_KEY) === '1'; } catch (e) { return false; } }
  function setReminded() { try { sessionStorage.setItem(REMIND_KEY, '1'); } catch (e) {} }
  function closeRemind(box) { if (box && box.parentNode) box.parentNode.removeChild(box); document.removeEventListener('keydown', onKey); }
  function onKey(e) { if (e.key === 'Escape') closeRemind(document.querySelector('.gp-remind')); }
  function showRemind(left, g, btn) {
    var box = document.createElement('div');
    box.className = 'gp-remind';
    box.innerHTML =
      '<div class="gp-remind-bg" data-gpr-close></div>' +
      '<div class="gp-remind-card" role="dialog" aria-modal="true" aria-labelledby="GpRemindH">' +
        '<button type="button" class="gp-remind-x" data-gpr-close aria-label="Luk">\u2715</button>' +
        '<div class="gp-remind-kick">Gratis gaver til gode \uD83C\uDF81</div>' +
        '<h2 id="GpRemindH" class="gp-remind-h">Husk at v\u00e6lge dine gaver!</h2>' +
        '<p class="gp-remind-p">Du har <b>' + left + ' ' + (left === 1 ? 'gavepoint' : 'gavepoint') + '</b>, som du ikke har brugt. V\u00e6lg dine gratis gaver, f\u00f8r du g\u00e5r til kassen \u2013 de koster ikke noget.</p>' +
        '<button type="button" class="btn full gp-remind-go" data-gpr-pick>V\u00e6lg mine gaver</button>' +
        '<button type="button" class="gp-remind-skip" data-gpr-skip>G\u00e5 til kassen uden gaver</button>' +
      '</div>';
    document.body.appendChild(box);
    document.addEventListener('keydown', onKey);
    var go = box.querySelector('[data-gpr-pick]'); if (go) go.focus();
    box.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-gpr-close]')) { closeRemind(box); return; }
      if (ev.target.closest('[data-gpr-pick]')) {
        closeRemind(box);
        if (g) {
          g.scrollIntoView({ behavior: 'smooth', block: 'start' });
          g.classList.remove('gp-flash'); void g.offsetWidth; g.classList.add('gp-flash');
        }
        return;
      }
      if (ev.target.closest('[data-gpr-skip]')) { closeRemind(box); btn.click(); }
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[name="checkout"]'); if (!btn || reminded()) return;
    var scope = btn.closest('[data-cart-drawer]') || btn.closest('.cart-sec') || document;
    var g = scope.querySelector('[data-gift]'); if (!g) return;
    var pts = parseInt(g.dataset.points, 10) || 0, used = parseInt(g.dataset.used, 10) || 0;
    var left = pts - used; if (left <= 0) return;
    if (!g.querySelector('[data-gift-add]:not([disabled])')) return;
    e.preventDefault(); e.stopPropagation();
    setReminded();
    showRemind(left, g, btn);
  }, true);

  function init() {
    if (document.body.classList.contains('template-cart')) { applyTab(document.querySelector('.cart-sec')); check(document.querySelector('.cart-sec')); }
    var d = document.querySelector('[data-cart-drawer]'); if (!d) return;
    var inner = d.querySelector('[data-cd-inner]'); if (!inner || !window.MutationObserver) return;
    new MutationObserver(function () { applyTab(d); setTimeout(function () { check(d); }, 30); }).observe(inner, { childList: true });
    applyTab(d); check(d);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
